import React, { useEffect, useState } from "react";
import "./ContactHeatmap.css";

import API_BASE from "../config/api";

// helper: format date to yyyy-mm-dd
function toYMD(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const ContactHeatmap = ({ days = 42 }) => {
  const [cells, setCells] = useState([]);

  useEffect(() => {
    const load = async () => {
      const today = new Date();
      const endStr = toYMD(today);

      const start = new Date();
      start.setDate(start.getDate() - (days - 1));
      const startStr = toYMD(start);

      try {
        const res = await fetch(
          `${API_BASE}/api/contacts/heatmap?from=${startStr}&to=${endStr}`
        );
        const data = await res.json();

        // map DB rows into a date -> count map
        const map = {};
        data.forEach((row) => {
          map[row.contact_date] = row.count;
        });

        // build full range, fill missing with 0
        const tmp = [];
        const cur = new Date(start);
        while (cur <= today) {
          const key = toYMD(cur);
          tmp.push({
            date: key,
            count: map[key] || 0,
          });
          cur.setDate(cur.getDate() + 1);
        }

        setCells(tmp);
      } catch (err) {
        console.error("Failed to load contact heatmap:", err);
      }
    };

    load();
  }, [days]);

  if (!cells.length) return null;

  // find max to scale intensity
  const maxCount = cells.reduce(
    (m, c) => (c.count > m ? c.count : m),
    0
  );

  const getLevel = (count) => {
    if (count === 0) return 0;
    if (maxCount <= 1) return 3; // everything same if few data
    const ratio = count / maxCount;
    if (ratio > 0.75) return 4;
    if (ratio > 0.5) return 3;
    if (ratio > 0.25) return 2;
    return 1;
  };

  // 7 columns (Mon–Sun style)
  return (
    <div className="heatmap-card">
      <div className="heatmap-header">
        <h3>Recruiter Contact Heatmap</h3>
        <span className="heatmap-subtitle">
          Last {cells.length} days – darker = more contacts
        </span>
      </div>

      <div className="heatmap-grid">
        {cells.map((c, idx) => {
          const level = getLevel(c.count);
          return (
            <div
              key={c.date + "-" + idx}
              className={`heatmap-cell heat-${level}`}
              title={`${c.date} – ${c.count} contact(s)`}
            >
              {/* optional small dot or count */}
              {c.count > 0 ? c.count : ""}
            </div>
          );
        })}
      </div>

      <div className="heatmap-legend">
        <span>0</span>
        <div className="legend-boxes">
          <div className="heatmap-cell heat-0" />
          <div className="heatmap-cell heat-1" />
          <div className="heatmap-cell heat-2" />
          <div className="heatmap-cell heat-3" />
          <div className="heatmap-cell heat-4" />
        </div>
        <span>{maxCount || 1}+ contacts</span>
      </div>
    </div>
  );
};

export default ContactHeatmap;
